import axios from "axios";
import { Fancybox, Carousel } from "@fancyapps/ui";

const uploadEndpoint = "/upload";

Fancybox.bind('[data-trix-attachment] a');
document.querySelectorAll('.carousel').forEach(carousel => {
    new Carousel(carousel, {
        slidesPerPage: 1,
        on: {
            ready(c) {
                let link = c.$container.dataset.link && document.querySelector(c.$container.dataset.link);
                if (link) {
                    link = link.cloneNode(true);
                    link.classList.add('carousel__link');
                    c.$container.appendChild(link);
                }
            },
        },
    });
});

window.addEventListener('console-log', (event) => {
    console.log(event.detail);
});

if (typeof Livewire !== 'undefined') {
    Livewire.on('gotoTop', () => {
        const main = document.body.querySelector('main');
        window.scrollTo({
            top: main ? main.offsetTop : 15,
            behaviour: 'smooth'
        })
    });

    Livewire.on('changeTheme', (theme) => {
        console.log(theme);
        if (theme === 'dark') {
            document.documentElement.classList.add('dark')
        } else {
            document.documentElement.classList.remove('dark')
        }
    });
}

window.addEventListener("trix-attachment-add", function(event) {
    if (event.attachment.file) {
        uploadFileAttachment(event.attachment)
    }
})

function uploadFileAttachment(attachment) {
    uploadFile(attachment.file, progress => {
        attachment.setUploadProgress(progress)
    }, attributes => {
        attachment.setAttributes(attributes)
    });
}

async function uploadFile(file, progressCallback, successCallback) {
    const { data: { data: response } } = await axios.post(uploadEndpoint, createFormData(file), {
        onUploadProgress: progressEvent => {
            const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
            if (totalLength !== null) {
                progressCallback(Math.round( (progressEvent.loaded * 100) / totalLength ));
            }
        },
    });

    successCallback({
        url: response.url,
        href: response.url + "?content-disposition=attachment"
    })
}

function createFormData(file) {
    const data = new FormData()
    data.append("Content-Type", file.type)
    data.append("file", file)
    return data
}
